import { render, staticRenderFns } from "./UpsiDetailsDialog.vue?vue&type=template&id=0e6e3b94"
import script from "./UpsiDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UpsiDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports